import { axiosInstance } from "../client";
import { Expression } from "@rumble-it/common-lib/types/models/Expression.interface";
import { CollectionResponse } from "@rumble-it/common-lib/types/api/CollectionResponse.interface";
import { PaginationParams } from "@rumble-it/common-lib/types/api/PaginationParams.interface";

interface QueryExpressionFilterParams extends PaginationParams {
  source: string;
}

export const fetchExpressions = async (
  params: QueryExpressionFilterParams,
): Promise<CollectionResponse<Expression>> =>
  axiosInstance
    .get("/query-expressions", {
      params,
    })
    .then((response) => response.data);
